module.exports = __webpack_public_path__ + "static/media/328409-PA7RGA-278.ee062171.jpg";